export const GOOGLE_PLAY_UPGRADE_REPLACEMENT_MODE =
  "IMMEDIATE_AND_CHARGE_PRORATED_PRICE";

const GOOGLE_PLAY_PLATFORM = "android-playstore";

export function isNativeSubscriptionUpgradeSupported({
  nativeApp,
  nativeAndroid,
  provider,
}) {
  if (!nativeApp) return true;
  return nativeAndroid ? provider === "google_play" : provider === "app_store";
}

const transactionProductIds = (transaction) =>
  (Array.isArray(transaction?.products) ? transaction.products : [])
    .map((product) => String(product?.id || product || "").trim())
    .filter(Boolean);

export function findGooglePlayPurchaseToken(receipts, productId) {
  const normalizedProductId = String(productId || "").trim();
  if (!normalizedProductId) return "";

  const candidates = Array.isArray(receipts) ? receipts : [];
  for (let index = candidates.length - 1; index >= 0; index -= 1) {
    const receipt = candidates[index];
    if (String(receipt?.platform || "") !== GOOGLE_PLAY_PLATFORM) continue;
    const hasProduct = (Array.isArray(receipt?.transactions) ? receipt.transactions : [])
      .some((transaction) => transactionProductIds(transaction).includes(normalizedProductId));
    if (!hasProduct) continue;

    const purchaseToken = String(receipt?.purchaseToken || "").trim();
    if (purchaseToken) return purchaseToken;
  }

  return "";
}

export function buildGooglePlaySubscriptionUpgradeData(receipts, currentProductId) {
  const oldPurchaseToken = findGooglePlayPurchaseToken(receipts, currentProductId);
  if (!oldPurchaseToken) {
    const error = new Error(
      "The current Google Play subscription could not be found on this device."
    );
    error.code = "native_store_current_subscription_missing";
    throw error;
  }

  return {
    googlePlay: {
      oldPurchaseToken,
      replacementMode: GOOGLE_PLAY_UPGRADE_REPLACEMENT_MODE,
    },
  };
}
